import { render, staticRenderFns } from "./BubbleList.vue?vue&type=template&id=687b84ad&scoped=true"
import script from "./BubbleList.vue?vue&type=script&lang=js"
export * from "./BubbleList.vue?vue&type=script&lang=js"
import style0 from "./BubbleList.vue?vue&type=style&index=0&id=687b84ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687b84ad",
  null
  
)

export default component.exports